export default __webpack_public_path__ + "static/media/Brow_7_C2.cdf0577a.svg";